<template>
    <div>
        <b-card header="Almacenamiento de productos químicos - Auditar matriz de compatibilidad"
            header-class="font-weight-bold">

            <b-row>
                <b-col cols="12" sm="4">
                    <b-form-group label="Producto" label-for="product">
                        <b-form-input id="product" v-model="filtersHistory.product"
                            placeholder="Ingrese nombre de un producto" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="2">
                    <b-form-group label="Estado" label-for="status">
                        <el-select v-model="filtersHistory.status" size="medium" id="status" clearable>
                            <el-option key="pending" label="Pendiente" value="pending"></el-option>
                            <el-option key="approved" label="Aprobado" value="approved"></el-option>
                            <el-option key="rejected" label="Rechazado" value="rejected"></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" sm="2" class="d-flex align-items-end">
                    <b-form-group label-for="actions">
                        <b-button variant="primary" @click="searchHistory">Buscar</b-button>
                        <b-button variant="secondary" class="ml-2" @click="clearFilter()">Limpiar</b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table class="mt-3" responsive striped hover :items="history.data" :fields="fields"
                empty-text="No hay registros para mostrar" show-empty>
                <template v-slot:cell(result)="data">
                    <b-badge :variant="data.item.result == 1 ? 'success' : 'danger'">{{ data.item.result == 1 ?
                        'Compatible' : 'Incompatible'
                        }}</b-badge>
                </template>
                <template v-slot:cell(status)="data">
                    <b-badge
                        :variant="data.item.status == 'pending' ? 'warning' : data.item.status == 'approved' ? 'success' : 'danger'">
                        {{ data.item.status == 'pending' ? 'Pendiente' : data.item.status == 'approved' ? 'Aprobado'
                            :
                            'Rechazado' }}
                    </b-badge>
                </template>
                <template v-slot:cell(actions)="data">
                    <b-button variant="info" size="sm" v-b-tooltip.hover title="Auditar" class="float-left mx-1"
                        @click="audit(data.item)">
                        <i class="fa fa-handshake-o" style="color: white;"></i>
                    </b-button>
                </template>
            </b-table>

            <el-pagination v-model="filtersHistory.page" @size-change="afterChangeSizePagination"
                @current-change="afterChangePagePagination" :current-page.sync="filtersHistory.page" class="float-right"
                :page-size.sync="filtersHistory.perPage" :page-sizes="[10, 30, 50, 100]"
                layout="total, sizes, prev, pager, next" :total="history.total" />
        </b-card>

        <b-modal v-model="modal" title="Auditar Compatibilidad de Productos" centered size="xl">
            <comparison :products="products" />
            <div class="mt-3">
                <b-row v-if="!disabled">
                    <b-col cols="12" sm="4">
                        <b-form-group label="Compatibilidad" label-for="selectOption">
                            <el-select v-model="auditInfo.result" id="selectOption">
                                <el-option v-for="item in options" :key="item.value" :label="item.text"
                                    :class="item.value == 1 ? 'status-compatible' : item.value == -1 ? 'status-incompatible' : 'status-revision'"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="12">
                        <b-form-group label="Observación" label-for="observation">
                            <b-form-textarea v-model="auditInfo.observation" id="observation"
                                placeholder="Ingrese una observación" rows="3"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-else>
                    <b-col cols="12">
                        <b-card no-body class="border-0 shadow-sm mb-3">
                            <b-card-header class="bg-primary text-white">
                                <h5 class="mb-0">
                                    <i class="fa fa-edit mr-2"></i>
                                    Detalles de la Auditoría
                                </h5>
                            </b-card-header>

                            <b-card-body>
                                <b-row>
                                    <b-col md="6">
                                        <b-list-group flush>
                                            <b-list-group-item
                                                class="d-flex justify-content-between align-items-center py-3">
                                                <span class="font-weight-bold text-muted">
                                                    <i class="fa fa-info-circle text-primary mr-2"></i>
                                                    Estado:
                                                </span>
                                                <b-badge :variant="getStatusVariant(info.status)" class="px-3 py-2">
                                                    {{ info.status == 'pending' ? 'Pendiente' : info.status ==
                                                        'approved' ?
                                                        'Aprobado' : 'Rechazado' }}
                                                </b-badge>
                                            </b-list-group-item>


                                            <b-list-group-item
                                                class="d-flex justify-content-between align-items-center py-3">
                                                <span class="font-weight-bold text-muted">
                                                    <i class="fa fa-check text-primary mr-2"></i>

                                                    Compatibilidad:
                                                </span>
                                                <b-badge
                                                    :class="info.result == 1 ? 'status-compatible' : 'status-incompatible'"
                                                    pill class="px-3 py-2">
                                                    {{ info.result == 1 ? 'Compatible' : 'Incompatible' }}
                                                </b-badge>
                                            </b-list-group-item>


                                            <b-list-group-item class="py-3">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span class="font-weight-bold text-muted">
                                                        <i class="fa fa-calendar text-primary mr-2"></i>
                                                        Fecha de Auditoría:
                                                    </span>
                                                    <span>{{ info.date_audit }}</span>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>


                                    <b-col md="6">
                                        <b-list-group flush>
                                            <b-list-group-item class="py-3">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span class="font-weight-bold text-muted">
                                                        <i class="fa fa-user text-primary mr-2"></i>
                                                        Auditor:
                                                    </span>
                                                    <div class="d-flex align-items-center">
                                                        <span>{{ info.auditor_user.name }}</span>
                                                    </div>
                                                </div>
                                            </b-list-group-item>


                                            <b-list-group-item class="py-3">
                                                <div class="d-flex flex-column">
                                                    <span class="font-weight-bold text-muted mb-2">
                                                        <i class="fa fa-comments text-primary mr-2"></i>
                                                        Observación:
                                                    </span>
                                                    <p class="mb-0 pl-4">{{ info.observation || 'Sin observaciones' }}
                                                    </p>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>

                    </b-col>
                </b-row>
            </div>
            <template v-slot:modal-footer>
                <b-button variant="danger" @click="modal = false">Cancelar</b-button>
                <b-button v-if="!disabled" variant="primary" @click="saveAudit">Guardar</b-button>
            </template>
        </b-modal>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import comparison from './Comparison';

export default {
    name: 'approve-matrix',
    components: {
        comparison
    },
    data() {
        return {
            fields: [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'status', label: 'Estado', sortable: false },
                { key: 'first_product.nombre', label: 'Producto', sortable: false },
                { key: 'second_product.nombre', label: 'Producto', sortable: false },
                { key: 'result', label: 'Compatibilidad', sortable: false },
                { key: 'created_at', label: 'Fecha de creación', sortable: true },
                { key: 'creator_user.name', label: 'Creado por', sortable: false },
                { key: 'actions', label: 'Acciones', sortable: false }
            ],
            products: null,
            modal: false,
            auditInfo: {
                id: null,
                result: null,
                observation: null
            },
            disabled: false,
            info: null
        };
    },
    computed: {
        ...mapState('matrizCompatibilidad', ['history', 'filtersHistory']),
        options() {
            return [
                {
                    value: 1,
                    text: 'Compatible'
                },
                {
                    value: -1,
                    text: 'Incompatible'
                },
                {
                    value: 0,
                    text: 'Rechazar'
                }
            ];
        }
    },
    mounted() {
        this.getHistory();
    },
    methods: {
        ...mapActions('matrizCompatibilidad', ['getHistory', 'saveAuditCompatibility']),
        ...mapMutations('matrizCompatibilidad', ['setDefaultFiltersHistory', 'loadAfterChangeSizePagination', 'loadAfterChangePagePagination', 'setDefaultFiltersHistory']),

        audit(item) {
            this.disabled = item.status == 'approved' || item.status == 'rejected';
            this.info = item;

            this.auditInfo = {
                id: item.id,
                result: item.result,
                observation: item.observation,
            };

            this.products = ['first_product', 'second_product'].map(key => {
                const attachment = item[key].attachments.find(attachment => attachment.adjunto);
                return {
                    name: item[key].nombre,
                    attachments: process.env.VUE_APP_API_URL + 'storage/files/' + (attachment ? attachment.adjunto : ''),
                    result: this.auditInfo.result
                };
            });

            this.modal = true;
        },
        async saveAudit() {
            if (!this.auditInfo.observation) {
                this.$alertError('Debe ingresar una observación');
                return;
            }
            const res = await this.saveAuditCompatibility(this.auditInfo);
            if (res) {
                this.modal = false;
                this.getHistory();
            }
        },
        getStatusVariant(status) {
            const variants = {
                'approved': 'success',
                'pending': 'warning',
                'rejected': 'danger'
            };
            return variants[status.toLowerCase()] || 'primary';
        },
        async clearFilter() {
            this.setDefaultFiltersHistory();
            await this.getHistory();
        },
        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getHistory();
        },
        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getHistory();
        },
        async searchHistory() {
            await this.getHistory(true);
        },
    }
};
</script>

<style scoped>
.status-incompatible {
    background-color: #f8d7da;
    color: #721c24;
}

.status-revision {
    background-color: #fff3cd;
    color: #856404;
}

.status-compatible {
    background-color: #d4edda;
    color: #155724;
}
</style>
